/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Placeholder, PlaceholderText, useBreakpoint } from 'sarsaparilla';

import styles from './HeroCarouselSkeleton.module.scss';

function PlaceholderCard() {
    return (
        <>
            <Placeholder
                className="my-half"
                height="100%"
                style={{ aspectRatio: '1.5/1' }}
                borderRadius="8px"
            />
            <PlaceholderText lines={2} fontSize={14} lineHeight={24} />
        </>
    );
}

export function HeroCarouselSkeleton() {
    const { isXlAndUp } = useBreakpoint();
    return (
        <div className={styles.skeleton}>
            <div className="mt-3">
                <div className={styles.carousel}>
                    {Array.from({ length: isXlAndUp ? 5 : 4 }).map((_, index) => (
                        <div className={styles.carouselItem} key={index}>
                            <PlaceholderCard />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
